'use strict';
const ansiRegex = require('ansi-regex');

module.exports = string => typeof string === 'string' ? string.replace(ansiRegex(), '') : string;



//////////////////
// WEBPACK FOOTER
// ./~/strip-ansi/index.js
// module id = 3828
// module chunks = 0